import { gql, MutationTuple, useMutation } from '@apollo/client';

export const DELETE_SAVED_COURSE_BY_STUDENT_ID = gql`
  mutation deleteSavedCourseByStudentId($courseId: NonEmptyString!, $providerId: NonEmptyString!) {
    deleteSavedCourseByStudentId(courseId: $courseId, providerId: $providerId)
  }
`;

interface ICreateStudentLearningPathwayParams {
  courseId: string;
  providerId: string;
}

interface ICreateStudentLearningPathwayResponse {
  deleteSavedCourseByStudentId: boolean;
}

export const useMutationDeleteSavedCourseByStudentId = (): MutationTuple<
  ICreateStudentLearningPathwayResponse,
  ICreateStudentLearningPathwayParams
> =>
  useMutation<ICreateStudentLearningPathwayResponse, ICreateStudentLearningPathwayParams>(
    DELETE_SAVED_COURSE_BY_STUDENT_ID,
  );
